var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section text-center w-full"},[_c('div',{staticClass:"flex flex-col items-center mb-6 w-full"},[_c('v-date-picker',{attrs:{"is-expanded":"","attributes":_vm.attrs},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }